import { DatePicker } from 'antd';

export default function CustomDatePicker(props) {
    return <DatePicker {...props} />;
}
